
export default {
	props: {
		phone: {
			type: String,
			default: ''
		}
	},
}
